import React from 'react'

import StudioButton from 'material/buttons/StudioButton'
import StudioForm, {yup} from 'studio/StudioForm'
import StudioInput from 'material/input/StudioInput'
import StudioLoading from 'studio/StudioLoading'
import StudioTitleBar from 'studio/StudioTitleBar'


class SignUpForm extends StudioForm {
    constructor(props) {super(props)
        this.state = {
            name: false,
            email: false,
            password: false,
            confirmPW: false,
            loading: false,
        }
    }

    renderChildren(props) {
        return (
            <React.Fragment>
                {this.state.loading && <StudioLoading/>}

                <StudioInput
                type='text'
                name='name'
                labelText={props.errors?.name ? props.errors.name : 'Display Name'}
                required={true}
                value={props.values?.name}
                error={this.state.name}
                onChange={props.handleChange}/>

                <StudioInput
                type='email'
                name='email'
                labelText={props.errors?.email ? props.errors.email : 'Email Address'}
                required={true}
                value={props.values?.email}
                error={this.state.email}
                onChange={props.handleChange}/>

                <StudioInput
                type='password'
                name='password'
                labelText={props.errors?.password ? props.errors.password : 'Password'}
                required={true}
                value={props.values?.password}
                error={this.state.password}
                onChange={props.handleChange}/>

                <StudioInput
                type='password'
                name='confirmPW'
                labelText={props.errors?.confirmPW ? props.errors.confirmPW : 'Confirm Password'}
                required={true}
                value={props.values?.confirmPW}
                error={this.state.confirmPW}
                onChange={props.handleChange}/>

                <StudioButton
                type='submit'
                text='Submit'
                variant='contained'
                size='large'
                form={this.formID()}/>
            </React.Fragment>
        )
    }

    formSchema() {
        return (
            yup.object().shape({
                name: yup.string()
                .min(2, 'Too Short')
                .max(24, 'Too Long'),

                email: yup.string()
                .max(75, 'Invalid Email Format')
                .email('Invalid Email Format'),

                password: yup.string()
                .min(8, 'Too Short')
                .max(63, 'Too Long'),

                confirmPW: yup.string()
                .min(8, 'Too Short')
                .max(63, 'Too Long')
                .oneOf([yup.ref('password'), null], 'Passwords Do Not Match'),
            })
        )
    }

    initialValues() {
        return ({
            name: '',
            email: '',
            password: '',
            confirmPW: '',
        })
    }

    formID() {
        return 'sign-up-form'
    }

    onSubmit(values) {
        this.setState({loading: true})

        const payload = {
            username: values.name,
            email: values.email,
            pw: values.password,
        }

        this.REST.POST('sign_up_form', payload)
        .then(response => this.handleResponse(response, values))
    }

    handleResponse(response, values) {
        this.setState({loading: false})

        if (response?.data?.formik_error) {
            this.setState({[response.data.formik_error]: true})
        }

        if (response.status === 201) {
            this.stateful({
                user: {
                    userName: values.name,
                    userMail: values.email,
                }
            })

            return this.props.history.push('confirm-code')
        }
    }

    renderTitleBar() {
        return <StudioTitleBar title='Sign Up'/>
    }
}

export default SignUpForm
